import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type RecoveryPasswordInput = {
	token: string;
	newPassword: string;
};

export type RecoveryPasswordUseCase = UseCase<RecoveryPasswordInput, void>;

export function recoveryPasswordBuilder(authRepository: AuthRepository): RecoveryPasswordUseCase {
	return async function recoveryPassword(input: RecoveryPasswordInput): Promise<void> {
		const token = stringValueObject().validate('token', input.token);
		const newPassword = stringValueObject().validate('newPassword', input.newPassword);

		return authRepository.recoveryPassword(newPassword, token);
	};
}
